module.exports = new __parcel__URL__("faq_expanded_zh-tw.55f96374.webp").toString();